import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import constants from 'src/constant.json';
import { CmaState } from '../cma.state';
import { ActivatedRoute } from '@angular/router';
declare const google:any;

@Component({
  selector: 'app-property-search',
  templateUrl: './property-search.component.html',
  styleUrls: ['./property-search.component.scss'],
})
export class PropertySearchComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() addressType: string;
  @Input() initialAddress: string;
  @ViewChild('searchField') searchField: any;
  constant: any = constants;
  autoCompleteInput: string;
  queryWait: boolean;
  subpremise: string;
  autocompleteEl: any;
  onDestroyNotifier$ = new Subject();
  isAddressFocused = false;

  constructor(
    private cmaState: CmaState,
    private cdr: ChangeDetectorRef,
    private appRef: ApplicationRef,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    if (this.initialAddress) {
      this.autoCompleteInput = this.initialAddress;
    }
  }

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
    this.getPlaceFromGeocoder();
  }

  ngOnDestroy(): void {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  async getPlaceAutocomplete() {
    const placesLibrary = await google.maps.importLibrary('places');
    const PlaceAutocompleteElement = (placesLibrary as any).PlaceAutocompleteElement;

    const autocomplete = new PlaceAutocompleteElement({
      componentRestrictions: { country: 'US' },
      types: ['geocode'],
    });

    autocomplete.setAttribute('no-input-icon', '');
    autocomplete.setAttribute('no-clear-button', '');

    this.searchField.nativeElement.parentElement.replaceChild(autocomplete, this.searchField.nativeElement);
    this.autocompleteEl = autocomplete;

    if (this.initialAddress) {
      autocomplete.value = this.initialAddress;
    }
     autocomplete.addEventListener('focus', () => {
      this.isAddressFocused = true;
      this.cdr.detectChanges();
    });
    autocomplete.addEventListener('blur', () => {
      this.isAddressFocused = false;
      this.cdr.detectChanges();
    })
    autocomplete.addEventListener('input', () => {
      this.autoCompleteInput = autocomplete.value;
      this.cdr.detectChanges();
    });
    autocomplete.addEventListener('gmp-select', async (event: any) => {
      const place = event.placePrediction.toPlace();
      await place.fetchFields({ fields: ['formattedAddress', 'addressComponents', 'location'] });

      this.invokeEvent(place);
      this.cdr.detectChanges();
    });
  }

  async invokeEvent(place?: any) {
    // support both the new Place fields and the legacy ones
    const components = place?.addressComponents || place?.address_components;
    const formatted = place?.formattedAddress || place?.formatted_address;

    if (place && components) {
      this.autoCompleteInput = formatted;
      await this.getPlaceFromGeocoder();
      this.appRef.tick();
    }
  }

  async getPlaceFromGeocoder() {
    if (!this.autoCompleteInput) return;

    try {
         const results = await new Promise((resolve, reject) => {
        new google.maps.Geocoder().geocode({ address: this.autoCompleteInput }, (results, status) => {
          if (status === 'OK') {
            resolve(results);
          } else {
            reject(status);
          }
        });
      });
      this.ngZone.run(() => {
        if (results && results[0]) {
          let locality: string = null;
          let subPremise: string = null;
          let streetNumber: string = null;
          let city: string = null;
          let state: string = null;
          let zip: string = null;
          results[0].address_components.forEach((result) => {
            if (result.types[0] == 'route') {
              locality = result.short_name;
            } else if (result.types.indexOf('subpremise') > -1) {
              subPremise = result.short_name;
            } else if (result.types.indexOf('street_number') > -1) {
              streetNumber = result.short_name;
            } else if (result.types.indexOf('locality') > -1 || result.types.indexOf('sublocality') > -1) {
              city = result.short_name;
            } else if (result.types.indexOf('administrative_area_level_1') > -1) {
              state = result.short_name;
            } else if (result.types.indexOf('postal_code') > -1) {
              zip = result.short_name;
            }
          });
          if (streetNumber) {
            let addressObj: any = {
              // StreetAddress: streetNumber + ' ' + locality,
              StreetNumber: streetNumber,
              StreetName: locality,
              City: city,
              State: state,
              Zip: zip,
              SubPremise:subPremise
            };
            if (subPremise) {
              let subPreFix = subPremise.toLowerCase();
              let isPrefixIncluded = this.constant.UNIT_PREFIX.some((prefix) =>
                subPreFix.includes(prefix.toLowerCase())
              );
              if (isPrefixIncluded == true) {
                addressObj.StreetName += ' ' + subPremise;
              } else {
                addressObj.StreetName += ' # ' + subPremise;
              }
            }
            this.cmaState.searchAddressValue = addressObj;
          }
        }
        this.cdr.detectChanges();
      });
    } catch (error) {
      console.error('Geocoding error:', error);
    }
  }
}